var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.906006 0.868277C0.787598 1.02476 0.72168 1.21724 0.72168 1.42324V9.57662C0.72168 9.76796 0.778748 9.94771 0.881821 10.0979L5.31816 5.47048L0.906006 0.868277Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72435 5.04674L7.16356 3.54558L2.10458 0.624823C1.88501 0.498022 1.63309 0.467963 1.39803 0.534033L5.72435 5.04674Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72435 5.89414L1.35431 10.4524C1.44853 10.4841 1.54604 10.5 1.64362 10.5C1.80193 10.5 1.96031 10.4583 2.10458 10.375L7.19995 7.43321L5.72435 5.89414Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16558 4.70151L7.68655 3.84755L6.13061 5.4704L7.72287 7.13132L9.16558 6.29834C9.45428 6.13172 9.62663 5.83318 9.62663 5.49993C9.62663 5.1666 9.45428 4.86814 9.16558 4.70151Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDark);
export default __webpack_public_path__ + "static/media/google-dark.0cce2f93f8eae54a728e09e4437dd49b.svg";
export { ForwardRef as ReactComponent };